import React from 'react'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { IssueLabel } from '../../../../components/entities/IssueLabel'
import { ConvertibleLabel } from '../../../../components/entities/ConvertibleLabel'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { IssuesGroup } from 'types/IssuesGroupEntity'

export function IssueGroups({
    entity,
    issueGroups,
    handleDeleteFromGroup,
    handleAddToGroup,
    isGuarantorFeeIssue,
}: {
    entity: { id: string }
    handleAddToGroup: (groupId: string) => void
    handleDeleteFromGroup: (groupId: string) => void
    issueGroups: Array<IssuesGroup>
    isGuarantorFeeIssue: boolean
}) {
    return (
        <>
            <Typography variant='body2'>Länkgrupper</Typography>
            <List>
                {issueGroups
                    ?.sort((a, b) => a.groupId.localeCompare(b.groupId)) // Sort to avoid flickering upon add/delete
                    .filter((ig) => {
                        if (!isGuarantorFeeIssue) return true

                        return ig.issues.some((e) => e.id === entity.id)
                    })
                    .map((ig) => {
                        const isInGroup =
                            ig.issues.some((i) => i.id === entity.id) || ig.convertibles.some((c) => c.id === entity.id)
                        return (
                            <ListItem key={ig.groupId} sx={{ border: 'dotted 1px', borderRadius: 3 }}>
                                <Stack direction='column' spacing={1}>
                                    {!isInGroup && (
                                        <Tooltip title='Lägg till i gruppen'>
                                            <IconButton onClick={() => handleAddToGroup(ig.groupId)}>
                                                <AddCircleOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {isInGroup && (
                                        <Tooltip title='Ta bort från gruppen'>
                                            <IconButton onClick={() => handleDeleteFromGroup(ig.groupId)}>
                                                <RemoveCircleOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Stack>
                                <List>
                                    {ig.issues.map((issue) => (
                                        <ListItem key={`${ig.groupId}_${issue.id}`}>
                                            <Typography variant='body2'>
                                                <IssueLabel adminLink issue={issue} />{' '}
                                                {entity.id === issue.id && ' (aktuell emission)'}
                                            </Typography>
                                        </ListItem>
                                    ))}
                                    {ig.convertibles.map((convertible) => (
                                        <ListItem key={`${ig.groupId}_${convertible.id}`}>
                                            <Typography variant='body2'>
                                                <ConvertibleLabel
                                                    adminLink
                                                    convertible={{ ...convertible, id: convertible.id }}
                                                />{' '}
                                                {entity.id === convertible.id && ' (aktuell konvertibel)'}
                                            </Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            </ListItem>
                        )
                    })}
            </List>
        </>
    )
}
